// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvatarPlaceholder__container-e674ee {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/AvatarPlaceholder/AvatarPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".container {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AvatarPlaceholder__container-e674ee`
};
module.exports = ___CSS_LOADER_EXPORT___;
